import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

export default function VerifyQuick() {
  const { certNum } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/verify', { replace: true, state: { certNum: certNum.toUpperCase(), quick: true } });
  }, [certNum, navigate]);

  return null;
}
